import { MDBCard, MDBCardImage, MDBCardOverlay, MDBCardTitle, MDBContainer } from "mdb-react-ui-kit";
import banner from '../../assets/banner.jpg'

export function MeetOurTeamBanner() {

    return (
        <>
            <MDBCard background='dark' className='text-white border border-0 border-success rounded-0 px-0'>
                <MDBCardImage className={'border border-0 border-danger rounded-0'} style={{ height: '450px' }} overlay src={banner} alt='banner' />
                <MDBCardOverlay className={'border border-0 border-danger rounded-0 d-flex align-items-center px-0'}>
                    <MDBContainer className={'border border-0 border-danger'}>
                        <MDBCardTitle className={'border border-0 border-danger h1'}>Meet Our Team</MDBCardTitle>
                    </MDBContainer>
                    {/* <MDBCardText>
                        This is a wider card with supporting text below as a natural lead-in to additional content. This
                        content is a little bit longer.
                    </MDBCardText>
                    <MDBCardText>Last updated 3 mins ago</MDBCardText> */}
                </MDBCardOverlay>
            </MDBCard>
        </>
    )
}